import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { supabase } from "../../integrations/supabase/client";
import { log, error } from '@/utils/logUtils';

/**
 * ProtectedRoute component that redirects to login if user is not authenticated
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - Child components to render when authenticated
 */
const ProtectedRoute = ({ children }) => {
  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const checkAuth = async () => {
      try {
        const { data } = await supabase.auth.getSession();
        setAuthenticated(!!data.session);
      } catch (err) {
        error('Error checking authentication:', err);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    // Also subscribe to auth changes
    const { data: authListener } = supabase.auth.onAuthStateChange(
      (event, session) => {
        log('Auth state changed:', event);
        setAuthenticated(!!session);
        setLoading(false);
      }
    );

    checkAuth();

    return () => {
      // Clean up subscription on unmount
      if (authListener && authListener.subscription) {
        authListener.subscription.unsubscribe();
      }
    };
  }, []);

  if (loading) {
    return <div className="flex items-center justify-center h-screen">Loading...</div>;
  }

  if (!authenticated) {
    return <Navigate to="/login" replace />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
